import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import pic1 from './pic1.jpg'
import pic2 from './pic2.jpeg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'


const Page = () => {

    const detail = 
        {
            id:1,
            imgSrc:pic1,
            ini:'International One Health Conference. Faculty of Associated Medical Sciences, Chiang Mai University, Thailand',
            href:'',
            element:'',
            topic:'',
            inform: `Miss Premmarin Inmonthian, a master’s student in the International Program in Medical Technology, Faculty of Medical Technology, Chiang Mai University, under the supervision of Asst. Prof. Dr. Woottichai Khumduang, delivered an oral presentation titled <b>“Whole Genome Sequencing Analysis of SARS-CoV-2 Household Transmission in Chiang Mai, Thailand During 2022–2024”</b> at the 32nd International Dynamics & Evolution of Human Viruses Conference, held from May 6–9, 2025, at the Abbaye de Royaumont, France. Her participation and presentation were supported by a student support grant from ANRS–MIE (France), along with additional support from the Division of Microbiology and the Department of Medical Technology, Faculty of Medical Technology, Chiang Mai University, and the Thailand VERDI-RECOVER research project.`,
            link1: `https://www.facebook.com/permalink.php?story_fbid=pfbid02EgKKbmYhp3RdjzPQe6uxWYVXYA2z2zwpZL2jcdpdNS7BQtnqZexHYSw9pCd5ZnSBl&id=100089824854973`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        }
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Page;
